<script>
    import { ShopBoxHelpApp } from "@shopboxai/shopbox-help-app";
    import { currentUser } from "../stores";
</script>

<ShopBoxHelpApp user={$currentUser} />
